/*
 * Customaly header behavior. Original work.
 * Mega menu tabs, category panels, and single-open dropdown handling.
 */
(function () {
  function selectMegaCategory(menu, button) {
    var target = button.getAttribute('data-cu-mega-category')

    menu.querySelectorAll('[data-cu-mega-category]').forEach(function (categoryButton) {
      var isActive = categoryButton === button

      categoryButton.classList.toggle('is-active', isActive)
      categoryButton.setAttribute('aria-selected', isActive ? 'true' : 'false')
    })

    menu.querySelectorAll('[data-cu-mega-panel]').forEach(function (panel) {
      var isActive = panel.getAttribute('data-cu-mega-panel') === target

      panel.hidden = !isActive
      panel.classList.toggle('is-active', isActive)
    })
  }

  function selectMegaTab(menu, button) {
    var target = button.getAttribute('data-cu-mega-tab')

    menu.querySelectorAll('[data-cu-mega-tab]').forEach(function (tabButton) {
      var isActive = tabButton === button

      tabButton.classList.toggle('is-active', isActive)
      tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false')
      tabButton.setAttribute('tabindex', isActive ? '0' : '-1')
    })

    menu.querySelectorAll('[data-cu-mega-tab-group]').forEach(function (group) {
      group.hidden = group.getAttribute('data-cu-mega-tab-group') !== target
    })

    var activeGroup = menu.querySelector('[data-cu-mega-tab-group="' + target + '"]')
    var firstCategory = activeGroup && activeGroup.querySelector('[data-cu-mega-category]')

    if (firstCategory) {
      selectMegaCategory(menu, firstCategory)
    }
  }

  function closeAllMenus(except) {
    document.querySelectorAll('.cu-menu-details[open]').forEach(function (details) {
      if (details !== except) {
        details.open = false
      }
    })
  }

  function initializeMegaMenus(scope) {
    var root = scope || document

    root.querySelectorAll('[data-cu-mega]').forEach(function (menu) {
      if (menu.dataset.cuMegaReady === 'true') {
        return
      }

      menu.dataset.cuMegaReady = 'true'

      menu.querySelectorAll('[data-cu-mega-tab]').forEach(function (button) {
        button.addEventListener('click', function () {
          selectMegaTab(menu, button)
        })
      })

      menu.querySelectorAll('[data-cu-mega-category]').forEach(function (button) {
        button.addEventListener('click', function () {
          selectMegaCategory(menu, button)
        })

        button.addEventListener('pointerenter', function () {
          if (window.matchMedia('(min-width: 769px)').matches) {
            selectMegaCategory(menu, button)
          }
        })
      })
    })

    root.querySelectorAll('.cu-menu-details').forEach(function (details) {
      if (details.dataset.cuDetailsReady === 'true') {
        return
      }

      details.dataset.cuDetailsReady = 'true'
      details.addEventListener('toggle', function () {
        if (details.open) {
          closeAllMenus(details)
        }
      })
    })
  }

  // <details> has no native outside-click close; without this the panel stays open.
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.cu-menu-details')) {
      closeAllMenus(null)
    }
  })

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeAllMenus(null)
    }
  })

  document.addEventListener('DOMContentLoaded', function () {
    initializeMegaMenus(document)
  })

  document.addEventListener('shopify:section:load', function (event) {
    initializeMegaMenus(event.target)
  })

  // Announcement bar dismissal. Dawn has no equivalent; ported from Expanse so the
  // bar stays closed for the rest of the session once the shopper shuts it.
  var announcementKey = 'cuAnnouncementDismissed'

  function hideAnnouncement(announcement) {
    announcement.hidden = true
  }

  function announcementWasDismissed() {
    try {
      return window.sessionStorage.getItem(announcementKey) === 'true'
    } catch (error) {
      return false
    }
  }

  function initializeAnnouncement() {
    if (!announcementWasDismissed()) {
      return
    }

    document.querySelectorAll('[data-cu-announcement]').forEach(hideAnnouncement)
  }

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest('[data-cu-announcement-close]')
    var announcement = closeButton && closeButton.closest('[data-cu-announcement]')

    if (!announcement) {
      return
    }

    try {
      window.sessionStorage.setItem(announcementKey, 'true')
    } catch (error) {
      // The bar can still be closed when storage is unavailable.
    }

    hideAnnouncement(announcement)
  })

  /* Mini cart ------------------------------------------------------------- */
  /* Rendered by Liquid; Dawn only re-renders `cart-icon-bubble` on a cart
     change, so pull the panel back through the section rendering API. */

  function refreshMiniCart() {
    var current = document.querySelector('[data-cu-mini-cart]')

    if (!current) {
      return
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'

    fetch(root + '?section_id=cu-mini-cart')
      .then(function (response) {
        return response.text()
      })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cu-mini-cart]')

        if (fresh) {
          current.replaceWith(fresh)
        }
      })
      .catch(function () {
        // The panel keeps its last rendered state when the refresh fails.
      })
  }

  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshMiniCart)
  }

  document.addEventListener('DOMContentLoaded', initializeAnnouncement)
  document.addEventListener('shopify:section:load', initializeAnnouncement)
})()
